"use client"

import { ThemeSetter } from "../../components/theme/ThemeProvider"

const WAYS_TO_PARTICIPATE = [
  {
    title: "Run a Light Node",
    description: "Install the light node on any device. It runs in the background and submits verified action proofs on your behalf — no configuration, no ongoing management.",
  },
  {
    title: "Become a Validator",
    description: "Validators are the backbone of the network. They verify action proofs, participate in consensus, and earn rewards for each epoch they secure.",
  },
  {
    title: "Build on the Protocol",
    description: "Integrate PhytonCoin into your product using the open APIs. Embed participation directly into your app, game, or platform.",
  },
]

export default function GamePage() {
  return (
    <>
      <ThemeSetter theme="dark" />
      <main className="hero">
        <section className="mx-auto flex max-w-6xl flex-col gap-12">
          <header className="space-y-4 text-center md:text-left">
            <span className="uppercase tracking-[0.4em] text-xs text-primary">Participate</span>
            <h1 className="font-grotesk text-4xl md:text-5xl">Earn PHY by Doing</h1>
            <p className="text-lg" style={{ color: "var(--text)" }}>
              No mining rigs. No capital required. Your contribution to the network is
              your participation — and every verified epoch is a chance to earn.
            </p>
          </header>

          <section className="grid gap-6 md:grid-cols-3">
            {WAYS_TO_PARTICIPATE.map(({ title, description }) => (
              <article
                key={title}
                className="rounded-2xl border border-muted p-6"
                style={{ background: "var(--surface)", boxShadow: "var(--shadow-soft)" }}
              >
                <h2 className="mb-3 text-xl font-semibold text-primary">{title}</h2>
                <p className="text-sm leading-relaxed" style={{ color: "var(--text)" }}>
                  {description}
                </p>
              </article>
            ))}
          </section>

          <div
            className="rounded-2xl border border-muted p-8"
            style={{ background: "var(--surface)", boxShadow: "var(--shadow-soft)" }}
          >
            <h2 className="text-2xl font-semibold">How Rewards Work</h2>
            <p className="mt-3 text-sm leading-relaxed" style={{ color: "var(--text)" }}>
              The network settles on a fixed cycle called an epoch. When an epoch closes,
              the protocol tallies all verified contributions and distributes PHY proportionally —
              automatically, with no intermediaries. The formula is public and unchanged by anyone.
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <a className="btn-primary" href="/integrations">Get the Light Node</a>
              <a className="btn-ghost" href="/explorer">View Network Activity</a>
            </div>
          </div>
        </section>
      </main>
    </>
  )
}
